import TippingLayout from "./Tipping";

export { TippingLayout };

export default {
	TippingLayout
}

export * from '../../../core/layouts';